import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { Ability } from "../../entities/abilities";

@Injectable()
export class AbilityRepo extends Repository<Ability>{
    constructor(private dataSource: DataSource) {
        super(Ability, dataSource.createEntityManager());
    }
}
